import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function getLoginPath() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  return `/admin-${dd}-${mm}`;
}

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, needsSetup } = useAuth();
  const location = useLocation();
  const loginPath = getLoginPath();

  if (loading) return null;

  if (needsSetup) {
    return <Navigate to="/setup" replace />;
  }

  if (!user) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/projekty" replace />;
  }

  return children;
}
